import React from 'react'
import PropTypes from 'prop-types'
import { Nav, NavDropdown, NavItem, Navbar } from 'react-bootstrap'
import { ASSETS_URL } from '../../constants/urls'
import SearchInput from '../../containers/ESSearch/SearchInput'
import expand from '../../assets/images/expand_more_sm.svg'
import logoLg from '../../assets/images/desktop_lg.svg'
import logoMobile from '../../assets/images/mobile-logo.svg'
import logoSm from '../../assets/images/desktop_sm.svg'
import { Category, CategoryTitle, NavigationV2 } from './styled'
import { images } from './images'
import '../../types'
import { getAbsoluteLink, getVersionIcon } from '../../helpers/utils'
import { NAV_MODULE_ICON } from '../../constants'

const Title = ({ title }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: '20px'
      }}
    >
      <div className="animated slideInLeft">{title}</div>
      <div className="animated fadeIn" style={{ animationDelay: '0.8s' }}>
        <img src={expand} alt="expand" />
      </div>
    </div>
  )
}

/**
 * @typedef {Object} NavbarV2Props
 * @property {Header} header
 * @property {function(): void} toggleDeviceModal
 * @property {TopLinks} topLinks
 * @property {string} version
 */

/**
 * NavbarV2
 * The main navigation component tree for within HeaderV2
 * @param {NavbarV2Props}
 * @returns {React.ElementType}
 */
const NavBarV2 = ({ header, topLinks, toggleSearchModal, version }) => {
  if (!Object.keys(header).includes('items')) return null
  const menuItems = header.items.navigation.items.slice(0, 5)

  return (
    <NavigationV2
      className="animated slideInDown navbar-shrink"
      id="nav-container"
    >
      <a
        id="brand"
        href={getAbsoluteLink('/', version)}
        className="hidden-xs hidden-sm"
      >
        <img
          alt="Straight Talk Wireless: Everything for Less Logo Homepage"
          srcSet={`${logoLg} 1024w, ${logoSm} 960w, ${logoMobile} 640w`}
        />
      </a>
      <Navbar className="upper-navbar hidden-sm hidden-xs" id="navbar">
        <Nav className="switches flex-hidden">
          <NavItem key={1} eventKey={1} href={topLinks.url}>
            <span>
              <img
                src={getVersionIcon(NAV_MODULE_ICON.language)}
                alt="language"
                height="24px"
              />
            </span>
            <span>{topLinks.text}</span>
          </NavItem>
          <NavItem key={2} eventKey={2} href="#" disabled>
            <span>
              <img
                src={getVersionIcon(NAV_MODULE_ICON.location)}
                alt="location"
                height="24px"
              />
            </span>
            <span>Enter your ZIP</span>
          </NavItem>
        </Nav>
        <Nav>
          {header.links.map((link, i) => {
            return (
              <NavItem
                className="text border flex-hidden"
                href={getAbsoluteLink(link.linkUrl, version)}
                alt={link.linkAltText}
                key={`${i}_nav-item_${link.linkText}`}
              >
                {link.linkText}
              </NavItem>
            )
          })}
          <NavItem className="icon" onClick={() => toggleSearchModal()}>
            <span>
              <img src={getVersionIcon(NAV_MODULE_ICON.search)} alt="search" className='black' height="20px"/>
            </span>
          </NavItem>
          <NavItem
            className="icon"
            href={getAbsoluteLink("wps/portal/home/h/MyAccount/login", version)}
          >
            <span>
              <img src={getVersionIcon(NAV_MODULE_ICON.person)} alt="account" />
            </span>
          </NavItem>
          <NavItem className="icon" href={getAbsoluteLink("shop/cart", version)}>
            <span>
              <img src={getVersionIcon(NAV_MODULE_ICON.shopping)} alt="shopping cart" />
            </span>
          </NavItem>
        </Nav>
      </Navbar>
      <Navbar className="lower-navbar">
        <Navbar.Header>
          <Navbar.Toggle />
          <a id="brand" href={getAbsoluteLink('/', version)} className="hidden-lg hidden-md">
            <img
              alt="Straight Talk Wireless: Everything for Less Logo Homepage"
              srcSet={`${logoLg} 1024w, ${logoSm} 960w, ${logoMobile} 640w`}
            />
          </a>
          <Nav className="hidden-lg hidden-md icons-container-sm">
            <NavItem
              className="icon"
              href={getAbsoluteLink("wps/portal/home/h/MyAccount/login", version)}
              style={{ padding: '10px' }}
            >
              <span>
                <img src={getVersionIcon(NAV_MODULE_ICON.person)} alt="account" />
              </span>
            </NavItem>
            <NavItem
              className="icon"
              href={getAbsoluteLink("shop/cart", version)}
              style={{ padding: '10px 20px 10px 0px' }}
            >
              <span>
                <img
                  src={getVersionIcon(NAV_MODULE_ICON.shopping)}
                  alt="shopping cart"
                />
              </span>
            </NavItem>
          </Nav>
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <div className="hidden-md hidden-lg search">
              <SearchInput
                toggleSearchModal={toggleSearchModal}
                aria-label="Search Mobile"
              />
            </div>
            {menuItems.map((item, i) => {
              const mItems = item.children.slice(0, 4)
              if (Array.isArray(mItems) && mItems.length > 0) {
                return (
                  <NavDropdown
                    key={`${i}_nav-dropdown_${item.title}`}
                    eventKey={3}
                    title={<Title title={item.title} />}
                    noCaret
                  >
                    <div className="title hidden-xs hidden-sm">
                      <h2>{item.title}</h2>
                      <p>{item.description}</p>
                    </div>
                    <div className="menu">
                      {mItems.map((item, i) => {
                        return (
                          <li key={`${i}_nav-item-title_${item.title}`}>
                            <CategoryTitle>
                              <img
                                src={images[item.title.toLowerCase()]}
                                className="hidden-xs hidden-sm"
                                alt={item.title}
                                height="80px"
                                width="80px"
                              />
                              <h3>{item.title}</h3>
                            </CategoryTitle>
                            <Category>
                              {item.children.map(child => {
                                return (
                                  <li key={child.title}>
                                    <a
                                      href={getAbsoluteLink(child.url, version)}
                                    >
                                      {child.title}
                                    </a>
                                  </li>
                                )
                              })}
                            </Category>
                          </li>
                        )
                      })}
                    </div>
                  </NavDropdown>
                )
              }
              return (
                <NavItem
                  key={`${i}_nav-title_${item.title}`}
                  className="dropdown border menu-item animated slideInLeft"
                  href={getAbsoluteLink(item.url, version)}
                >
                  <span style={{ paddingLeft: '20px' }}>{item.title}</span>
                </NavItem>
              )
            })}
          </Nav>
          <div className="hidden-lg hidden-md">
            <Nav>
              {header.links.map((link, i) => {
                return (
                  <NavItem
                    key={`${i}_nav-link-text_${link.linkText}`}
                    className="text border animated slideInLeft"
                    href={getAbsoluteLink(link.linkUrl, version)}
                    alt={link.linkAltText}
                  >
                    {link.linkText}
                  </NavItem>
                )
              })}
            </Nav>
            <Nav
              className="switches animated fadeOut"
              style={{ animationDelay: '0.8s' }}
            >
              <NavItem eventKey={1} href={topLinks.url}>
                <span>
                  <img
                    src={getVersionIcon(NAV_MODULE_ICON.language)}
                    alt="language"
                    height="24px"
                  />
                </span>
                <span className="small-text" style={{ textTransform: 'capitalize'}}>{topLinks.text}</span>
              </NavItem>
              <NavItem eventKey={2} href="#">
                <span>
                  <img
                    src={getVersionIcon(NAV_MODULE_ICON.location)}
                    alt="location"
                    height="24px"
                  />
                </span>
                <span className="small-text">Enter your ZIP</span>
              </NavItem>
            </Nav>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </NavigationV2>
  )
}

NavBarV2.propTypes = {
  version: PropTypes.string.isRequired,
  header: PropTypes.object.isRequired,
  toggleSearchModal: PropTypes.func.isRequired,
  topLinks: PropTypes.shape({
    show: PropTypes.bool,
    text: PropTypes.string,
    url: PropTypes.string.isRequired
  }).isRequired
}

export default NavBarV2



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarV2.js